import { render, staticRenderFns } from "./ShiftsPageOld.vue?vue&type=template&id=14bea35c&"
import script from "./ShiftsPageOld.vue?vue&type=script&lang=js&"
export * from "./ShiftsPageOld.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports